export const REBRAND_INFO_POPUP_FLAG = 'hasSeenRebrandPopupConfirmed';

export const REBRAND_INFO_URL = 'https://openx.showpad.com/share/Q49rMUR0g9kQj054EW6mX';

export const REBRAND_INFO_POPUP_EXPIRATION = Date.UTC(2025, 5, 1);
